module.exports = __webpack_public_path__ + "assets/ae1e5efeea9f248b1c346bfb328877c4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/konami_base_fallback.mp3
 ** module id = 363
 ** module chunks = 0
 **/